import { useQuery } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

import { fetchLayoutType } from '../layoutTypes';
import { mapViewChannel } from './helpers';

export const useViewChannelsName = (channelName: string) =>
  useQuery({
    queryKey: queryKeys.channels.all(`channelName=${channelName}`),
    queryFn: () => fetchViewChannelsName(channelName),
    enabled: Boolean(channelName),
  });

const fetchViewChannelsName = async (channelName: string) => {
  const url = `/viewChannels/${encodeURIComponent(channelName)}`;

  const [response, layoutTypes] = await Promise.all([
    requestCCApi({ url }),
    queryClient.fetchQuery({
      queryKey: queryKeys.layoutTypes.all(),
      queryFn: fetchLayoutType,
    }),
  ]);

  return mapViewChannel(response.data, layoutTypes);
};
